import React, { useState } from "react";
import { IDiscographyType } from "types/discographyType";
import styled from "styled-components";
import { Colors } from "utils/colors";
import Typography from "components/typography";
import { Link } from "react-router-dom";
import TrackMenu from "pages/dashboard/overview/components/track-menu";
import TrackBlockItem from "pages/dashboard/overview/components/track-block-item";
import { SongWithUrls, ReleaseContainerWithUrls } from "types/response-type";
import DateConvert from "utils/dateConvert";

interface IProps {
  data: (SongWithUrls | ReleaseContainerWithUrls)[];
}
const BlockView = ({ data }: IProps) => {
  return (
    <Container>
      {data.map((data, i) => {
        return <TrackBlockItem data={data} key={i} />;
      })}
    </Container>
  );
};

export default BlockView;

const Container = styled.div`
  width: 100%;
  display: grid;
  justify-content: space-between;
  grid-template-columns: 32% 32% 32%;
  grid-row-gap: 1.6rem;
  @media only screen and (max-width: 769px) {
    grid-template-columns: 100%;
  }
`;

const ItemContainer = styled.div`
  padding: 0.8rem;
  height: 100%;
  width: 100%;
  border-radius: 0.8rem;
  background: ${Colors.grey700};
  position: relative;
  overflow: hidden;
`;

const Image = styled.img`
  width: 100%;
  object-fit: cover;
  border-radius: 0.8rem;
  margin-bottom: 2.1rem;
`;

const Status = styled.div<{ status: string }>`
  width: fit-content;
  position: absolute;
  padding: 0.4rem 0.8rem;
  top: 0;
  left: 0;
  border-radius: 0px 4px 4px 0px;
  box-shadow: 0px 4px 5.5px 0px rgba(0, 0, 0, 0.15);
  background-color: ${(props) =>
    props.status === "released"
      ? Colors.success
      : props.status === "inactive"
      ? Colors.danger
      : Colors.yellow500};
`;

const FlexBox = styled.div`
  display: flex;
  align-items: end;
  margin-bottom: 0.4rem;
`;
const TextArea = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
const TextLink = styled(Link)`
  all: unset;
  cursor: pointer;
`;

const OptionsButton = styled.div`
  width: 3rem;
  height: 3rem;
  cursor: pointer;
  position: relative;
`;
